type Props = {
  collapsed: boolean;
};

export default function SidebarLogo({ collapsed }: Props) {
  // Logos en frontend/public:
  // - Logo 1.png: con fondo
  // - Logo 2 sin fondo.png: sin fondo
  // - Logo 3 sin fondo solo.png: sin fondo (aparece en el estado contraído)

  if (collapsed) {
    return (
      <div className="w-10 h-10 rounded-xl flex items-center justify-center mx-auto bg-transparent">
        <img
          src="/Logo 3 sin fondo solo.png"
          alt="ProjectFlow Pro"
          className="w-9 h-9 object-contain"
        />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center w-full">
      <img
        src="/Logo 2 sin fondo.png"
        alt="ProjectFlow Pro"
        className="w-36 h-auto object-contain"
      />
    </div>
  );
}

